import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase, ref } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCqf1iRrzBMVNXASeRAYmKRcmFjHngA2l0",
  authDomain: "soujus-ca2bf.firebaseapp.com",
  databaseURL: "https://soujus-ca2bf-default-rtdb.firebaseio.com",
  projectId: "soujus-ca2bf",
  storageBucket: "soujus-ca2bf.firebasestorage.app",
  messagingSenderId: "365095528062",
  appId: "1:365095528062:web:fa806c3a2f1867410a1a2f",
  measurementId: "G-W9RVE2R8BY"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);
const storage = getStorage(app);

export const getAuthentication = async () => {
  return auth;
}

export const getRef = async (url) => {
  return ref(db, url);
}

export const addDocument = async (path, doc) => {
  try {
    // Verificar se o arquivo possui conteúdo
    if (!doc || !doc.file) {
      return { error: "O arquivo está vazio ou não contém conteúdo." };
    }

    // Enviar o conteúdo do arquivo para o Firebase Storage
    const uploadTaskSnapshot = await uploadBytesResumable(storageRef(storage, `${path}/${doc.name}`), doc.file);

    // Obter a URL de download após o upload
    const url = await getDownloadURL(uploadTaskSnapshot.ref);

    // Adicione o URL de download ao documento
    doc.link_download = url;

    return { url: url };
  } catch (error) {
    return { error: "Erro ao enviar o arquivo para o Firebase Storage: " + error };
  }
}

export const searchDocument = async (url) => {
  const fileRef = storage.refFromURL(url);

  // Baixa o URL do arquivo
  fileRef.getDownloadURL()
    .then((url) => {
      // Use o URL para fazer o que quiser, como abrir em uma nova janela ou fazer o download
      window.open(url);
    })
    .catch((error) => {
      console.error("Erro ao obter URL de download:", error);
    });
}
